module.exports = __webpack_public_path__ + "img/typeall.f82b03ed.png";